import Common from "../../../Common"

export type CompanyPbxModuleLockKeys = "pbx_destination_id" | "pbx_did_id"

export interface CompanyPbxModuleLockStatusIdValue {
	locked: boolean
	locked_by?: {
		username: string
		company_name: string
		pbx_user_id: id
		pbx_company_id: id
		session: id
	}
}

export type CompanyPbxModuleLockStatusValue = {
	[id: id]: CompanyPbxModuleLockStatusIdValue
}

export type CompanyPbxModuleLockStatus = Partial<Record<CompanyPbxModuleLockKeys, CompanyPbxModuleLockStatusValue>>

export type CompanyPbxModuleStatusBody = Partial<Record<CompanyPbxModuleLockKeys, id[]>>

export interface CompanyPbxModuleLockBody {
	session?: string
	locks: CompanyPbxModuleStatusBody
}

export interface CompanyPbxModuleLock {
	session?: string
}

export type CompanyPbxModuleStatus = CompanyPbxModuleLockStatus & {
	time: number
}

const ModuleLock = class extends Common {
	status = (companyId: id, body: CompanyPbxModuleStatusBody): CustomResponse<CompanyPbxModuleStatus> =>
		this.get(`/company/${companyId}/pbx/module/status`, body)

	lock = (companyId: id, body?: CompanyPbxModuleLockBody): CustomResponse<CompanyPbxModuleLock> =>
		this.post(`/company/${companyId}/pbx/module/lock`, body)

	unlock = (companyId: id, body?: CompanyPbxModuleLockBody) =>
		this.post(`/company/${companyId}/pbx/module/unlock`, body)
}

export default ModuleLock
